export const config = {
  additionalShopTitle: 'The Beauty Society is currently only available in some of our shops.',
  beautyMessage: `No location near you? <a href="https://jland.partners/35hnuML" target="_blank" rel="noopener noreferrer">Book a virtual consultation</a>.`,
};
